import { type ShortUrlResponse } from '@air/api/types';

/** The wire union for `presentationSettings.coverWidth` — option values on authoring surfaces mirror it verbatim. */
export type ShowcaseCoverWidth = NonNullable<NonNullable<ShortUrlResponse['presentationSettings']>['coverWidth']>;

/*
 * The absent-value fallback for `presentationSettings.coverWidth`. This MUST equal what the public
 * renderer (`PublicShowcaseCover`) renders when the field is absent: links saved before the field
 * existed have no `coverWidth` and must keep rendering the original flush full-width band. The
 * authoring surfaces (`ShowcaseEditorDesignProvider`, `CreateShowcaseDesignProvider`)
 * default from the same constant so the editor never shows a selection that differs from what a
 * legacy link actually renders. Lives in the shared collection folder (not the share-modal feature
 * folder) so the public viewer doesn't import from an authoring feature tree.
 */
export const COVER_WIDTH_DEFAULT: ShowcaseCoverWidth = 'fullWidth';
